import React from 'react';
import { fmt } from '../../../design/format';
import { asDate, fmtClock } from '../callFormat';
import { LEGEND_KINDS } from './callDetailModel';

const LIGHT_KINDS = ['transfer', 'forward'];
const ALWAYS_IN_LEGEND = ['aa', 'queue', 'agent', 'transfer'];

/** "Call route" card: proportional lineage track with durations, axis, and the timed step list. */
export function CallRoute({ route, startTime, stepsTruncated }) {
  const total = route.reduce((sum, hop) => sum + hop.seconds, 0);
  const kinds = new Set(route.map((h) => h.kind));
  const legend = LEGEND_KINDS.filter(([kind]) => ALWAYS_IN_LEGEND.includes(kind) || kinds.has(kind));
  const start = asDate(startTime).getTime();
  let elapsed = 0;

  return (
    <section className="card" data-testid="call-lineage">
      <div className="card-head">
        <div>
          <div className="t">Call route</div>
          <div className="d">
            {route.length} {route.length === 1 ? 'segment' : 'segments'} from the Teams call record · {fmt.mmss(total)} total
            {stepsTruncated ? ' · route truncated after 40 steps' : ''}
          </div>
        </div>
        <div className="acts legend">
          {legend.map(([kind, label]) => (
            <span key={kind}>
              <i style={{ background: `var(--route-${kind})` }} />
              {label}
            </span>
          ))}
        </div>
      </div>
      <div className="card-body">
        <div className="table-wrap" style={{ paddingTop: 4 }}>
          <div style={{ minWidth: 640 }}>
            <div className="lin-track">
              {route.map((hop, i) => {
                const wide = total > 0 && hop.seconds / total >= 0.14;
                return (
                  <div
                    key={i}
                    className={`lin-seg${LIGHT_KINDS.includes(hop.kind) ? ' light' : ''}`}
                    style={{ flex: Math.max(hop.seconds, total * 0.045), background: `var(--route-${hop.kind})` }}
                    title={`${hop.label}: ${hop.name}, ${fmt.mmss(hop.seconds)}`}
                  >
                    {wide && (
                      <span className="nm">
                        <span className="k">{hop.label}</span>
                        {hop.name}
                      </span>
                    )}
                    {fmt.mmss(hop.seconds)}
                  </div>
                );
              })}
            </div>
            <div className="lin-axis">
              {[0, 0.25, 0.5, 0.75, 1].map((p) => (
                <span key={p}>{fmt.mmss(total * p)}</span>
              ))}
            </div>
          </div>
        </div>
        <ol className="lin-list">
          {route.map((hop, i) => {
            const at = start + elapsed * 1000;
            elapsed += hop.seconds;
            return (
              <li key={i} data-testid="lineage-step">
                <span className="tm">{fmtClock(new Date(at))}</span>
                <span className="nd" style={{ color: `var(--route-${hop.kind})` }} />
                <div>
                  <div className="small">
                    <strong>{hop.name}</strong> <span className="muted">{hop.label.toLowerCase()}</span>
                  </div>
                  {hop.caption && <div className="caption">{hop.caption}</div>}
                </div>
                <span className="dur">{fmt.mmss(hop.seconds)}</span>
              </li>
            );
          })}
          <li>
            <span className="tm">{fmtClock(new Date(start + elapsed * 1000))}</span>
            <span className="nd" style={{ color: 'var(--text-3)' }} />
            <div className="small">
              <strong>Call ended</strong>
            </div>
            <span />
          </li>
        </ol>
      </div>
    </section>
  );
}
